module.exports = __webpack_public_path__ + "img/do.19306ca7.svg";